import * as React from "react";

function SvgAddIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        isolation: "isolate",
      }}
      viewBox="0 15.417 35.833 35.833"
      width={47.777}
      height={47.777}
      {...props}
    >
      <defs>
        <clipPath id="add-icon_svg__a">
          <path d="M0 15.417h35.833V51.25H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#add-icon_svg__a)">
        <path
          d="M35.833 35.417H20V51.25h-4.167V35.417H0V31.25h15.833V15.417H20V31.25h15.833v4.167z"
          fill="#DEDEDE"
        />
      </g>
    </svg>
  );
}

export default SvgAddIcon;
